'use strict';

$(document).ready(function () {
    $('body').on('click', '.topic-item', function (e) {
        e.preventDefault();
        if ( $('.topic-card').hasClass('active') ) {
            $('.topic-card').removeClass('active');
        }
        $(this).parent().addClass('active');
        $('body').spinner().start();
        $.get($(this).attr('href'), function (data) {
            if (data.success) {
                $('.faq-topic__content--body').empty();
                for (let index = 0; index < data.questions.length; index++) {
                    $('.faq-topic__content--body').append('<article class="row my-3" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"><div class="col-1 col-sm-auto gray-75 b1 font-weight-bold" aria-hidden="true">' + (index+1) + '</div><div class="col-10 col-sm-11"itemprop="name"><h2 class="font-weight-bold" style="font-size:1rem;">' + (data.questions[index] ? data.questions[index] : '') + '</h2><div  itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer"><p itemprop="text">' + (data.answers[index] ? data.answers[index] : '') + '</p></div></div></article>');
                }
                $('.faq-topic__content--body').append('<br>');
                $('body').spinner().stop();
            } else {
                $('.faq-topic__content--body').empty();
                $('.faq-topic__content--body').append('<p>' + data.errorMessage + '</p><br>');
                $('body').spinner().stop();
            }
        });
    });
});
